import "react-status-alert/dist/status-alert.css";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import { popupResponse } from "../../interfaces/popupInterfaces";
import { getActivePopups } from "../../Services/PopupsService";

export const Activepopups = () => {
  const [popups, setPopups] = useState<popupResponse[]>([]);

  const getAll = () => {
    getActivePopups().then((response) => {
      if (response.data && response.data.data) {
        setPopups(response.data.data);

        //console.log(response.data.data);
         if(response.data.data){

          response.data.data.map(single =>{
            showMessage(single)
          })

         }

  
      }
    });
  };

  useEffect(() => {
    getAll();
  }, []);


  const showMessage = (popup:popupResponse)=>{

//    let timerInterval;
    Swal.fire({
      title: '',
      icon: "success",
      html: popup.contenido,
      showCloseButton: false,
      showConfirmButton: false,
      timerProgressBar: false,
      allowOutsideClick: false,
      allowEscapeKey: false, 
      didOpen: () => {
        Swal.showLoading()
        setTimeout(() => {
          Swal.hideLoading();
          Swal.update({
            showCloseButton: true,
            showConfirmButton: false
          });
        }, 2000);
      },
      willClose: () => {
        //clearInterval(timerInterval);
      },
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log("I was closed by the timer");
      }
    });

  }

  return (
    <>
 
    </>
  );
};
